import { __ } from '@wordpress/i18n'

export default {
  cookies: __('Cookies', 'dhsv_theme'),
}
